import { render, staticRenderFns } from "./LinkTenantSettingRoot.vue?vue&type=template&id=85b26956&scoped=true"
import script from "./LinkTenantSettingRoot.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingRoot.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingRoot.vue?vue&type=style&index=0&id=85b26956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b26956",
  null
  
)

export default component.exports